import template from './user-payment-details.html';
import userPaymentDetailsController from './user-payment-details.controller';
import './user-payment-details.styl';

let userPaymentDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template,
  controller: userPaymentDetailsController,
  controllerAs: 'vm'
};

export default userPaymentDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-payment-details/user-payment-details.component.js
 **/